
import { defineComponent } from "vue";

export default defineComponent({
  name: "preview-link",
  inheritAttrs: false,
  props: {
    title: { type: String, default: "" },
    icon: { type: String, default: "bi bi-box-arrow-up-right" },
    externalTargetBlank: { type: Boolean, default: true },
    routerName: {
      type: Object,
      default: () => {
        "dashboard";
      },
    },
  },
});
